module.exports = "/_next/static/images/5d0ee92a65d18e695e348e0a50b309f6-wow@1x.png.webp";